import { NoticeEditorComp } from "../components/notices/noticeEditorComp";
import { useNavigate, useParams } from "react-router-dom";
import { useAtomValue } from "jotai";
import { editingNoticeAtom } from "../atoms/editingNoticeAtom";

export function NoticeEditor() {
  const { artistId, eventId, rewardId } = useParams();
  const artistIdNum = Number(artistId) || 0;
  const eventIdNum = Number(eventId) || 0;
  const rewardIdNum = Number(rewardId) || 0;
  const navigate = useNavigate();
  const editingNotice = useAtomValue(editingNoticeAtom);

  return (
    <>
      <NoticeEditorComp
        initialNotice={editingNotice}
        artistId={artistIdNum}
        eventId={eventIdNum}
        rewardId={rewardIdNum}
        onSave={() => navigate(-1)}
        onCancel={() => navigate(-1)}
      />
    </>
  );
}
